<script lang="ts">
  import UserWorkingHoursEditor from "../../../../../../_shared/_modules/user-working-hours-editor"
  import type { UserViewFrameContext } from "../../../../_shared/_logic/user-types"
  import type { PageContext } from "../../../working-hours/navigation"

  const { viewFrameContext, pageContext } = $props<{
    viewFrameContext: UserViewFrameContext
    pageContext: PageContext
  }>()

  // Working hours are product settings of the organization membership, not of the person.
  const membershipId = $derived(viewFrameContext.member?.membershipId ?? null)
  const organizationId = $derived(pageContext.organizationId)
  const loading = $derived(pageContext.loading ?? false)
  const error = $derived(pageContext.error ?? null)
  const onRetry = $derived(pageContext.onRetry ?? null)
</script>

{#key `${organizationId ?? "unresolved"}:${membershipId ?? "unresolved"}`}
  <UserWorkingHoursEditor {membershipId} {organizationId} {loading} {error} {onRetry} />
{/key}
